import { PaginationedData } from "../types/apiTypes";
import { ContactFormType, Equipment, IdType, ModulTypes, ScrapedVehicleType, WhiteListedVehicle } from "../types/appTypes";
import getApiEndpoint from "./apiEndpoint";
import http from "./httpService";
import { getApiQuery } from "./urlQueryService";

const apiEndpoint = `${getApiEndpoint()}/misc`;

export const latestCasesUrl = `${apiEndpoint}/latestCases`;
export const partnershipGroupsUrl = `${apiEndpoint}/partnershipGroups`;

export const caseListUrl = (context: ModulTypes, id: IdType, query?: string) =>
  `${apiEndpoint}/caseList?filter[${context}]=${id}&${getApiQuery(query)}`;


export function scrapeLink(link: string) {
  return http.post<{ data: ScrapedVehicleType }>(`${apiEndpoint}/scrapeLink`, { link });
}

export function getNewPrice({ vin, firstRegDate, type, motorAtlasId }: { vin: string, firstRegDate: string, type: 'optimization' | 'preAssessment', motorAtlasId: string | undefined }) {
  return http.post<{
    data: { amount: number, source: string }
  }>(`${getApiEndpoint()}/vehicleValuation/newPrice`, { vin, type, firstRegDate, motorAtlasId });
}

export function loadEquipmentsByVin(data: { vin: string, firstRegDate?: string | null }) {
  return http.post(`${getApiEndpoint()}/vehicleValuation/equipments`, data);
}

export function loadPotentialEquipments(data: { vin?: string, motorAtlasId?: string, firstRegDate?: string }) {
  return http.post<{
    data: { equipments: Equipment[] }
  }>(`${getApiEndpoint()}/vehicleValuation/potentialEquipments`, data);
}

export function contactSupport(data: ContactFormType) {
  return http.post(`${apiEndpoint}/contactSupport`, {
    message: data.message,
    type: data.type,
    url: window.location.href
  });
}

export function getCVRData(cvr: string) {
  return http.get(`${apiEndpoint}/cvrData/${cvr}`);
}


/** Check if a company of the given CVR is already in the system.
 *
 * Route::get('misc/cvrData/{cvr}/inUse' -> {data: boolean}
*/
export function isCVRInUse(cvr: string) {
  return http.get<{ data: boolean }>(`${apiEndpoint}/cvrData/${cvr}/inUse`);
}

export function toggleEmailSubscription(status: boolean) {
  return http.post<{ data: boolean }>(`${apiEndpoint}/toggleEmailSubscription`, {
    'status': status
  });
}

export function fetchWhiteListedVehicles() {
  return http.get<PaginationedData<WhiteListedVehicle>>(`${apiEndpoint}/taxCaseAutoOfferWhitelist?per_page=9999`);
}
